<script setup lang="ts">
defineProps<{
    hasJobAdServices?: boolean;
    hasTalentServices?: boolean;
    horizontal?: boolean;
}>();

const runtimeConfig = useRuntimeConfig();
const content_Url = runtimeConfig.public.karriere.content.url;
</script>

<template>
    <div
        class="flex flex-col justify-between gap-4 rounded-lg border border-gray-900 px-4 py-10 md:p-6 md:pt-16"
    >
        <div
            :class="`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 items-center gap-6 ${
                horizontal ? 'md:grid-cols-[1fr,2fr] xl:grid-cols-1' : ''
            }`"
        >
            <NuxtImg
                src="/illustrations/basic-direction-post.svg"
                width="150px"
                class="mx-auto"
                alt=""
            />
            <div class="flex flex-col gap-6">
                <div class="flex flex-col gap-2">
                    <BaseHeading variant="lg-500">
                        Welches Stelleninserat ist das richtige für Sie?
                    </BaseHeading>
                    <BaseText variant="base-400">
                        Unser Produktberater hilft Ihnen bei der
                        Entscheidungsfindung.*
                    </BaseText>
                </div>
                <JamBaseButton
                    variant="gray"
                    :to="`${content_Url}/hr/stelleninserate/produktberater`"
                    target="_blank"
                    full-width
                >
                    Jetzt Produktberater starten
                </JamBaseButton>
                <CommExcentosLegalText class="text-xs leading-4" />
            </div>
        </div>
    </div>
</template>
